<!--
 * @Author: your name
 * @Date: 2021-09-07 18:55:00
 * @LastEditTime: 2021-09-18 14:52:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/courseMain.vue
-->
<!--  -->
<template>
  <div class="main-img">
    <div class="back-btn" v-if="!$root.$data.isApp&&!this.$root.miniprogram">
      <img @click="handleBackBtnClick" src="@/assets/img/public/back.png" alt="返回" />
      <img @click="toShare" src="@/assets/img/public/share.png" alt="返回" />
    </div>
    <img class="img" :src="courseBaseData.coverMobile" alt="" />
    <contention-dialog
      :dialogShow="showContentionDialog"
      :onClose="confirmBack"
      :onStay="openChat"
      @close="dialogClose"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { copyTool } from '@/utils/tools';
import ContentionDialog from '@/components/RetentionDialog/index.vue';

export default {
  components: {
    ContentionDialog,
  },
  data() {
    return {
      version: '',
      showContentionDialog: false,
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  mounted() {
    // app 点击返回时触发
    window.beforePageLeave = this.beforePageLeave;
  },
  methods: {
    // 头部返回按钮
    handleBackBtnClick() {
      if (this.courseBaseData?.sellPrice >= 500) {
        this.showContentionDialog = true;
        this.confirmBack = this.goBack;
      } else {
        this.goBack();
      }
    },

    goBack() {
      if (sessionStorage.getItem('back')) {
        sessionStorage.removeItem('back');
        this.$router.go(-1);
        return;
      }
      this.$router.push({
        path: '/home',
      });
    },
    toShare() {
      const url = window.location.href;
      copyTool(url)
        .then(() => {
          this.$toast('复制成功,快去分享好友吧！');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    dialogClose() {
      this.showContentionDialog = false;
    },

    openChat() {
      mantis.requestChat();
    },

    beforePageLeave() {
      if (this.courseBaseData?.sellPrice >= 500) {
        this.showContentionDialog = true;
        this.confirmBack = () => {
          this.$sendToApp('closePage');
        };
      } else {
        this.$sendToApp('closePage');
      }
    },
    confirmBack() {},
  },
};
</script>

<style lang="scss" scoped>
.main-img {
  position: relative;
  width: 100%;
  height: 543px;
  > .img {
    display: block;
    width: 100%;
    height: 543px;
  }
  .back-btn {
    position: absolute;
    top: 30px;
    // left: 30px;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 30px;
    // height: 64px;
    // cursor: pointer;

    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
